<template>
  <div class="wba-root">

    <div class="wba-header">
      <div class="wba-header__brand">
        <svg class="wba-header__logo" viewBox="0 0 48 48" xmlns="http://www.w3.org/4000/svg">
          <rect width="48" height="48" rx="10" fill="#25D366" />
          <path fill="#fff"
            d="M24 8C15.163 8 8 15.163 8 24c0 2.837.742 5.594 2.153 8.022L8 40l8.241-2.118A15.93 15.93 0 0024 40c8.837 0 16-7.163 16-16S32.837 8 24 8zm0 29.333a13.267 13.267 0 01-6.758-1.847l-.485-.288-5.03 1.292 1.334-4.867-.317-.502A13.267 13.267 0 0110.667 24C10.667 16.636 16.636 10.667 24 10.667S37.333 16.636 37.333 24 31.364 37.333 24 37.333zm7.27-9.927c-.398-.199-2.354-1.161-2.72-1.294-.365-.133-.63-.199-.896.199-.265.398-1.028 1.294-1.26 1.56-.232.265-.464.298-.862.1-.398-.2-1.681-.619-3.202-1.976-1.183-1.056-1.982-2.36-2.214-2.758-.232-.398-.025-.614.174-.812.179-.178.398-.464.597-.696.199-.232.265-.398.398-.663.133-.265.066-.497-.033-.696-.1-.199-.896-2.16-1.228-2.957-.323-.776-.651-.671-.896-.683l-.763-.013c-.265 0-.696.1-1.061.497-.365.398-1.393 1.361-1.393 3.32s1.426 3.85 1.625 4.116c.199.265 2.806 4.283 6.798 6.006.95.41 1.691.655 2.269.838.953.303 1.821.26 2.507.158.765-.114 2.354-.962 2.687-1.891.332-.929.332-1.725.232-1.891-.099-.166-.365-.265-.763-.464z" />
        </svg>
        <div>
          <h1 class="wba-header__title">WhatsApp Business</h1>
          <span class="wba-header__sub">Campanhas oficiais via API Meta</span>
        </div>
      </div>
      <span class="wba-badge wba-badge--green">
        <span class="wba-badge__dot"></span>API Oficial Meta
      </span>
    </div>

    <!-- Tabs -->
    <div class="wba-tabs">
      <button class="wba-tab" :class="{ 'wba-tab--active': activeTab === 'campanha' }" @click="activeTab = 'campanha'">
        <i class="fas fa-paper-plane" style="font-size:13px;"></i>
        Nova Campanha
      </button>
      <!-- <button class="wba-tab" :class="{ 'wba-tab--active': activeTab === 'relatorio' }"
        @click="activeTab = 'relatorio'">
        <i class="fas fa-table" style="font-size:13px;"></i>
        Relatórios
      </button> -->
    </div>

    <!-- Nova Campanha -->
    <div v-if="activeTab === 'campanha'" class="wba-body">

      <div class="wba-notice">
        <i class="fas fa-info-circle" style="font-size:14px; margin-top:1px; flex-shrink:0;"></i>
        <span>Apenas templates aprovados pela Meta podem ser enviados. Cada telefone selecionado conta como 1 envio
          (limite de {{ limiteTotal }} por 24h).</span>
      </div>

      <!-- Card de saldo -->
      <div class="wba-saldo-wrap">
        <div class="wba-saldo-card">
          <div class="wba-saldo-icon" :class="saldoIconClass">
            <svg class="wba-header__logo" viewBox="0 0 48 48" xmlns="http://www.w3.org/4000/svg">
              <rect width="48" height="48" rx="10" fill="#25D366" />
              <path fill="#fff"
                d="M24 8C15.163 8 8 15.163 8 24c0 2.837.742 5.594 2.153 8.022L8 40l8.241-2.118A15.93 15.93 0 0024 40c8.837 0 16-7.163 16-16S32.837 8 24 8zm0 29.333a13.267 13.267 0 01-6.758-1.847l-.485-.288-5.03 1.292 1.334-4.867-.317-.502A13.267 13.267 0 0110.667 24C10.667 16.636 16.636 10.667 24 10.667S37.333 16.636 37.333 24 31.364 37.333 24 37.333zm7.27-9.927c-.398-.199-2.354-1.161-2.72-1.294-.365-.133-.63-.199-.896.199-.265.398-1.028 1.294-1.26 1.56-.232.265-.464.298-.862.1-.398-.2-1.681-.619-3.202-1.976-1.183-1.056-1.982-2.36-2.214-2.758-.232-.398-.025-.614.174-.812.179-.178.398-.464.597-.696.199-.232.265-.398.398-.663.133-.265.066-.497-.033-.696-.1-.199-.896-2.16-1.228-2.957-.323-.776-.651-.671-.896-.683l-.763-.013c-.265 0-.696.1-1.061.497-.365.398-1.393 1.361-1.393 3.32s1.426 3.85 1.625 4.116c.199.265 2.806 4.283 6.798 6.006.95.41 1.691.655 2.269.838.953.303 1.821.26 2.507.158.765-.114 2.354-.962 2.687-1.891.332-.929.332-1.725.232-1.891-.099-.166-.365-.265-.763-.464z" />
            </svg>
          </div>
          <div class="wba-saldo-body">
            <p class="wba-saldo-label">Envios restantes hoje</p>
            <div class="wba-saldo-nums">
              <div class="wba-saldo-num-group">
                <span class="wba-saldo-num-label">Usado</span>
                <span class="wba-saldo-num">{{ usado.toLocaleString('pt-BR') }}</span>
              </div>
              <span class="wba-saldo-sep">/</span>
              <div class="wba-saldo-num-group">
                <span class="wba-saldo-num-label">Restantes</span>
                <span class="wba-saldo-num" :class="saldoNumClass">{{ disponivel.toLocaleString('pt-BR') }}</span>
              </div>
              <span class="wba-saldo-sep">/</span>
              <div class="wba-saldo-num-group">
                <span class="wba-saldo-num-label">Total</span>
                <span class="wba-saldo-num">{{ limiteTotal.toLocaleString('pt-BR') }}</span>
              </div>
            </div>
            <div class="wba-saldo-bar-track">
              <div class="wba-saldo-bar-fill" :class="saldoBarClass" :style="{ width: usadoPct + '%' }"></div>
            </div>
            <div class="wba-saldo-footer">
              <span :class="saldoPctClass">{{ saldoPctLabel }}</span>
              <span v-if="proximoSlot" class="wba-saldo-renova">
                <i class="fas fa-calendar-alt" style="font-size:11px;"></i>
                Renova em {{ proximoSlot }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Banner bloqueio -->
      <div v-if="disponivel === 0" class="wba-blocked-banner">
        <div class="wba-blocked-banner__left">
          <i class="fas fa-ban" style="font-size:28px; color:#ff4d4f;"></i>
        </div>
        <div class="wba-blocked-banner__body">
          <p class="wba-blocked-banner__title">Envios bloqueados por hoje</p>
          <p class="wba-blocked-banner__desc">
            Você atingiu o limite de <strong>{{ limiteTotal }} envios</strong> nas últimas 24 horas.
            Nenhuma campanha poderá ser disparada até a renovação do período.
          </p>
          <div v-if="proximoSlot" class="wba-blocked-banner__renew">
            <i class="fas fa-clock" style="font-size:13px;"></i>
            Envios liberados novamente em: <strong>{{ proximoSlot }}</strong>
          </div>
        </div>
      </div>

      <div class="wba-grid">

        <div class="wba-card">
          <div class="wba-card__header">
            <span class="wba-card__title">1. Contatos</span>
            <span class="wba-counter" :class="counterClass">{{ contacts.length }} / {{ disponivel }}</span>
          </div>
          <upload-contatos :limit="disponivel" @contacts-loaded="onContactsLoaded"
            @contacts-cleared="onContactsCleared" />
        </div>

        <div class="wba-card wba-card--preview">
          <div class="wba-card__header">
            <span class="wba-card__title">2. Template</span>
          </div>
          <preview-whatsapp :selected-template="selectedTemplate" :variables="templateVariables"
            @open-selector="$refs.selectTemplate.openModal()" />
          <select-template ref="selectTemplate" @template-selected="onTemplateSelected"
            @preview-updated="onPreviewUpdated" />
          <div class="wba-footer-inner">
            <div class="wba-field">
              <label class="wba-label">Nome da campanha</label>
              <input type="text" class="wba-input" placeholder="Ex: Promocao Junho 2025" v-model="campanha"
                maxlength="80" />
            </div>
            <button class="wba-btn-send" @click="submitCampaign" :disabled="sending || !canSubmit">
              <span v-if="!sending">
                <i class="fas fa-paper-plane" style="font-size:13px;"></i>
                Enviar Campanha
              </span>
              <span v-else class="wba-spinner"></span>
            </button>
          </div>
        </div>

      </div>
    </div>

    <!-- Relatórios -->
    <!-- <div v-if="activeTab === 'relatorio'" class="wba-body">
      <status-campanhas />
    </div> -->

  </div>
</template>

<script>
import UploadContatos from './UploadContatos.vue';
import PreviewWhatsapp from './PreviewWhatsapp.vue';
import SelectTemplate from './SelectTemplate.vue';
import StatusCampanhas from './StatusCampanhas.vue';
import { mapActions } from 'vuex';

export default {
  name: 'MarketingIndex',
  components: { UploadContatos, PreviewWhatsapp, SelectTemplate, StatusCampanhas },
  props: { wallets: { type: Array, default: function () { return []; } } },
  data() {
    return {
      activeTab: 'campanha',
      contacts: [],
      campanha: '',
      selectedTemplate: null,
      templateVariables: [],
      templateParams: [],
      campaignPayload: [],
      templateText: '',
      sending: false,
      disponivel: 650,
      limiteTotal: 650,
      proximoSlot: null,
      // Nome do arquivo (já como salvo no servidor, ver UploadContatos.vue)
      // usado para essa campanha. Precisa ir junto no payload de cada item
      // para o backend saber qual arquivo mover para _old após o envio.
      uploadedFileName: ''
    };
  },
  computed: {
    usado() { return this.limiteTotal - this.disponivel; },
    usadoPct() { return this.limiteTotal > 0 ? Math.round((this.usado / this.limiteTotal) * 100) : 0; },
    pctDisponivel() { return 100 - this.usadoPct; },
    saldoPctLabel() { return this.disponivel === 0 ? 'Limite atingido' : this.pctDisponivel + '% disponivel'; },
    saldoBarClass() {
      if (this.pctDisponivel === 0) return 'wba-saldo-bar-fill--danger';
      if (this.pctDisponivel < 20) return 'wba-saldo-bar-fill--warn';
      return 'wba-saldo-bar-fill--ok';
    },
    saldoIconClass() {
      if (this.disponivel === 0) return 'wba-saldo-icon--danger';
      if (this.pctDisponivel < 20) return 'wba-saldo-icon--warn';
      return 'wba-saldo-icon--ok';
    },
    saldoNumClass() {
      if (this.disponivel === 0) return 'wba-saldo-num--danger';
      if (this.pctDisponivel < 20) return 'wba-saldo-num--warn';
      return 'wba-saldo-num--ok';
    },
    saldoPctClass() {
      if (this.disponivel === 0) return 'wba-saldo-pct wba-saldo-pct--danger';
      if (this.pctDisponivel < 20) return 'wba-saldo-pct wba-saldo-pct--warn';
      return 'wba-saldo-pct wba-saldo-pct--ok';
    },
    counterClass() {
      if (this.contacts.length > this.disponivel) return 'wba-counter--danger';
      if (this.contacts.length > Math.floor(this.disponivel * 0.9)) return 'wba-counter--warn';
      return '';
    },
    canSubmit() {
      return this.contacts.length > 0
        && this.contacts.length <= this.disponivel
        && !!this.selectedTemplate
        && this.campanha.trim() !== '';
    }
  },
  methods: {
    ...mapActions(['sendCampaign']),

    async fetchDisponivel() {
      try {
        const { data } = await axios.get('/marketing/campanha-saldo');
        this.disponivel = data.disponivel;
        this.limiteTotal = data.limite || 650;
        this.proximoSlot = data.proximo || null;
      } catch (e) {
        this.disponivel = 650; this.limiteTotal = 650; this.proximoSlot = null;
      }
    },

    _suffixFromFile(fileName) {
      if (!fileName) return '';
      var base = fileName.replace(/\.[^.]+$/, '');
      var parts = base.split('_');
      return parts.length > 1 ? parts[parts.length - 1] + '_'  : '';
    },

    onContactsLoaded(payload) {
      var list = Array.isArray(payload) ? payload : (payload.contacts || []);
      var fileName = Array.isArray(payload) ? '' : (payload.fileName || '');

      this.contacts = list;
      this.uploadedFileName = fileName;

      // sempre sobrescreve o nome com o sufixo do novo arquivo
      var suffix = this._suffixFromFile(fileName);
      if (suffix) this.campanha = suffix;

      this.buildPayload();
    },

    onContactsCleared() { this.contacts = []; this.campaignPayload = []; this.campanha = ''; this.uploadedFileName = ''; },
    onTemplateSelected(tpl) { this.selectedTemplate = tpl; this.buildPayload(); },
    onPreviewUpdated(payload) {
      this.templateVariables = payload.variables || [];
      this.templateParams = payload.params || [];
      this.templateText = payload.text || '';
      this.buildPayload();
    },

    buildPayload() {
      if (!this.contacts.length) { this.campaignPayload = []; return; }
      var tpl = this.selectedTemplate, params = this.templateParams, self = this;
      this.campaignPayload = this.contacts.map(function (c) {
        return {
          phone: c.phone || c.telefone || '',
          nome: c.nome || '',
          cpfCnpj: c.cpfCnpj || '',
          name: tpl ? tpl.name : '',
          language: tpl ? (tpl.language || 'pt_BR') : 'pt_BR',
          parameters: params.length ? params : [],
          template_body: tpl ? (self.templateText || '') : '',
          link_pagamento: c.linkPagamento || '',
          titulos: c.titulos || [],
          telefones: c.telefones || [],
          template_buttons: tpl
            ? ((tpl.components || []).find(function (comp) { return comp.type === 'BUTTONS'; })?.buttons || [])
            : [],
          // nome do arquivo de origem, usado pelo backend para mover o
          // arquivo para /_old depois que a campanha for enviada
          fileName: self.uploadedFileName || '',
          // Campos extras do CSV (Grupo;Fila;Consultor;Nome da Empresa;E-mail;Departamento;Divisão;Status),
          // usados pelo backend para preencher at_wallets
          grupo: c.grupo || '',
          fila: c.fila || '',
          consultor: c.consultor || '',
          empresa: c.empresa || '',
          email: c.email || '',
          departamento: c.departamento || '',
          divisao: c.divisao || '',
          statusContato: c.statusContato || ''
        };
      });
    },

    submitCampaign() {
      if (!this.campaignPayload.length) {
        Swal.fire({ type: 'error', title: 'Nenhum contato selecionado!', text: 'Selecione pelo menos 1 contato.' }); return;
      }
      if (!this.selectedTemplate) {
        Swal.fire({ type: 'error', title: 'Template nao selecionado!', text: 'Selecione um template aprovado pela Meta.' }); return;
      }
      if (this.contacts.length > this.disponivel) {
        Swal.fire({ type: 'warning', title: 'Limite insuficiente', text: 'Voce tem ' + this.disponivel + ' envios disponiveis hoje.' }); return;
      }

      this.sending = true;
      var self = this, id = Date.now();
      var name = this.campanha.trim() || ('campanha-' + id);

      this.campaignPayload.forEach(function (el) {
        var phone = el.phone || '';
        if (phone.indexOf('@s.whatsapp.net') !== -1) phone = phone.split('@')[0];
        el.phone = phone; el.formattedPhone = phone;
        el.id = String(id); el.campaignName = name;
      });

      axios.post('/marketing/addCampaign', this.campaignPayload)
        .then(function (res) {
          var d = res.data;
          var enviados = d.enviados !== undefined ? d.enviados : self.campaignPayload.length;
          var saldo = d.disponiveis !== undefined ? d.disponiveis : 0;
          self.disponivel = saldo;
          self.proximoSlot = d.proximo || null;
          var msg = 'Os clientes selecionados receberao as mensagens em breve.';
          if (d.cortou) msg = 'Apenas ' + enviados + ' mensagens enviadas. Saldo restante: ' + saldo + '.';
          self.sendCampaign(self.campaignPayload.slice(0, enviados));
          Swal.fire('Campanha "' + name + '" iniciada.', msg, 'success').then(function () { location.reload(); });
          self.campanha = ''; self.contacts = []; self.campaignPayload = [];
          self.selectedTemplate = null; self.templateParams = []; self.templateVariables = [];
          self.uploadedFileName = '';
        })
        .catch(function (err) {
          var msg = 'Verifique os dados e tente novamente.';
          if (err.response && err.response.status === 429) { msg = err.response.data.message || 'Limite diario atingido.'; self.fetchDisponivel(); }
          Swal.fire({ icon: 'error', title: 'Erro ao enviar', text: msg });
        })
        .finally(function () { self.sending = false; });
    }
  },

  mounted() { this.fetchDisponivel(); }
};
</script>

<style scoped>
.wba-root {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: #f0f2f5;
  min-height: 100vh;
}

.wba-header {
  background: #fff;
  border-bottom: 1px solid #e9edef;
  padding: 16px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.wba-header__brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.wba-header__logo {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.wba-header__title {
  font-size: 17px;
  font-weight: 600;
  color: #111b21;
  margin: 0;
  line-height: 1.2;
}

.wba-header__sub {
  font-size: 12px;
  color: #667781;
  display: block;
  margin-top: 1px;
}

.wba-badge {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.wba-badge--green {
  background: #d9fdd3;
  color: #0a5e2a;
}

.wba-badge__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #25d366;
  animation: blink 2s infinite;
}

@keyframes blink {

  0%,
  100% {
    opacity: 1
  }

  50% {
    opacity: .35
  }
}

.wba-saldo-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.wba-saldo-card {
  background: #fff;
  border: 1px solid #e9edef;
  border-radius: 10px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 350px;
}

.wba-saldo-icon {
  width: 32px;
  height: 32px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.wba-saldo-icon--ok {
  background: #d9fdd3;
}

.wba-saldo-icon--warn {
  background: #fff8e1;
}

.wba-saldo-icon--danger {
  background: #fde8e8;
}

.wba-saldo-body {
  flex: 1;
  min-width: 0;
}

.wba-saldo-label {
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #adb5bd;
  margin: 0 0 5px;
}

.wba-saldo-nums {
  display: flex;
  align-items: baseline;
  gap: 5px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}

.wba-saldo-num-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.wba-saldo-num-label {
  font-size: 9px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: #adb5bd;
}

.wba-saldo-num {
  font-size: 16px;
  font-weight: 600;
  color: #111b21;
  line-height: 1.2;
}

.wba-saldo-num--ok {
  color: #0a5e2a;
}

.wba-saldo-num--warn {
  color: #7c6000;
}

.wba-saldo-num--danger {
  color: #c62828;
}

.wba-saldo-sep {
  font-size: 14px;
  color: #dee2e6;
  margin: 0 1px;
  align-self: center;
}

.wba-saldo-bar-track {
  width: 100%;
  height: 4px;
  background: #f0f2f5;
  border-radius: 99px;
  overflow: hidden;
  margin-bottom: 5px;
}

.wba-saldo-bar-fill {
  height: 100%;
  border-radius: 99px;
  transition: width .4s ease;
}

.wba-saldo-bar-fill--ok {
  background: #25d366;
}

.wba-saldo-bar-fill--warn {
  background: #fcaf26;
}

.wba-saldo-bar-fill--danger {
  background: #e53935;
}

.wba-saldo-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px;
}

.wba-saldo-pct {
  font-size: 11px;
  font-weight: 500;
}

.wba-saldo-pct--ok {
  color: #0a5e2a;
}

.wba-saldo-pct--warn {
  color: #7c6000;
}

.wba-saldo-pct--danger {
  color: #c62828;
}

.wba-saldo-renova {
  font-size: 10px;
  color: #adb5bd;
  display: flex;
  align-items: center;
  gap: 3px;
}

.wba-tabs {
  background: #fff;
  border-bottom: 1px solid #e9edef;
  padding: 0 28px;
  display: flex;
  margin-top: -1px;
  justify-content: center;
}

.wba-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 14px 18px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #667781;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  transition: color .15s, border-color .15s;
}

.wba-tab:hover {
  color: #111b21;
}

.wba-tab--active {
  color: #00a884;
  border-bottom-color: #00a884;
}

.wba-body {
  padding: 24px 28px;
}

.wba-blocked-banner {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: #fff1f0;
  border: 1.5px solid #ffccc7;
  border-left: 5px solid #ff4d4f;
  border-radius: 10px;
  padding: 18px 22px;
  margin-bottom: 20px;
}

.wba-blocked-banner__left {
  flex-shrink: 0;
  margin-top: 2px;
}

.wba-blocked-banner__body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wba-blocked-banner__title {
  font-size: 15px;
  font-weight: 700;
  color: #5c0011;
  margin: 0;
}

.wba-blocked-banner__desc {
  font-size: 13px;
  color: #840014;
  margin: 0;
  line-height: 1.5;
}

.wba-blocked-banner__renew {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #5c0011;
  background: rgba(255, 77, 79, .08);
  border-radius: 6px;
  padding: 5px 10px;
  width: fit-content;
}

.wba-notice {
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 8px;
  padding: 10px 14px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  color: #7c6000;
  margin-bottom: 20px;
}

.wba-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  align-items: start;
  min-height: 300px;
}

@media (max-width: 860px) {
  .wba-grid {
    grid-template-columns: 1fr;
  }
}

.wba-card {
  background: #fff;
  border: 1px solid #e9edef;
  border-radius: 12px;
  overflow: hidden;
  min-height: 340px;
}

.wba-card--preview {
  display: flex;
  flex-direction: column;
}

.wba-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px 12px;
  border-bottom: 1px solid #f0f2f5;
  flex-shrink: 0;
}

.wba-card__title {
  font-size: 14px;
  font-weight: 600;
  color: #111b21;
}

.wba-counter {
  font-size: 12px;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 20px;
  background: #d9fdd3;
  color: #0a5e2a;
  transition: background .2s, color .2s;
}

.wba-counter--warn {
  background: #fff8e1;
  color: #7c6000;
}

.wba-counter--danger {
  background: #fde8e8;
  color: #c62828;
}

.wba-footer-inner {
  padding: 14px 18px;
  border-top: 1px solid #f0f2f5;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.wba-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 160px;
}

.wba-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: #667781;
}

.wba-input {
  height: 42px;
  padding: 0 14px;
  border: 1.5px solid #e9edef;
  border-radius: 8px;
  font-size: 14px;
  color: #111b21;
  background: #fff;
  outline: none;
  transition: border-color .15s;
  width: 100%;
}

.wba-input:focus {
  border-color: #00a884;
}

.wba-btn-send {
  height: 42px;
  padding: 0 24px;
  background: #25d366;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background .15s, transform .1s;
  white-space: nowrap;
}

.wba-btn-send:hover:not(:disabled) {
  background: #20bc5a;
}

.wba-btn-send:active:not(:disabled) {
  transform: scale(.98);
}

.wba-btn-send:disabled {
  background: #c8e6c9;
  cursor: not-allowed;
}

.wba-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, .4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin .7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>